import { PROMOTIONALBANNERDATA_GET_SUCCESS } from '../actionTypes/PromotionalBannerActionTypes';

const removeEmptyKeyValues = (offerData = {}, deviceType = {}) => {
    if (!offerData.contentExpiry) {
        return offerData;
    }

    const contentDate = new Date(offerData.contentExpiry);
    const currentDate = new Date();
    let offerDataArray = [];

    if (contentDate >= currentDate) {
        const { isTablet, isMobile } = deviceType;
        let deviceTypeToRenderOfferData = 'large';
        if (isMobile) {
            deviceTypeToRenderOfferData = 'small';
        } else if (isTablet) {
            deviceTypeToRenderOfferData = 'medium';
        }
        const offerDataForDevice = offerData[deviceTypeToRenderOfferData] || [];
        offerDataArray = offerDataForDevice.filter((offerItem) => offerItem.promoText);
    }
    return offerDataArray;
};

function OfferDetailsReducer(state = [], action) {
    let promotionalBannerData = [];
    switch (action.type) {
        case PROMOTIONALBANNERDATA_GET_SUCCESS:
            if (action.promotionalBannerData && action.promotionalBannerData.data) {
                promotionalBannerData = removeEmptyKeyValues(
                    action.promotionalBannerData.data,
                    action.params.deviceType
                );
            } else if (action.promotionalBannerData === '') {
                promotionalBannerData = [];
            } else if (
                action.promotionalBannerData &&
                action.promotionalBannerData.data === undefined
            ) {
                promotionalBannerData = {};
            }
            return {
                content: promotionalBannerData,
                isReady: true,
            };
        default:
            return state;
    }
}

OfferDetailsReducer.reducerName = 'promotionalBannerData';
export default OfferDetailsReducer;
